import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { RootComponent } from './components/root/root.component';
import { CanActivateIfLoggedIn, CanActivateIfNewUser, CanActivateLoginRequired } from './shared/services/custom/canActivate';
import { PageChiSiamoComponent } from './pages/page-chi-siamo/page-chi-siamo.component';
import { ShopBlockedGuard } from './shared/services/custom/shop-blocked.guard';
import { PagePolicyDittaComponent } from './pages/page-policy-ditta/page-policy-ditta.component';
import { SiteInfoComponent } from './components/site-info/site-info.component';
import { EditPageComponent } from './components/edit-page/edit-page.component';
import { AdminPageComponent } from './components/admin-page/admin-page.component';
import { ListMenuComponent } from './pages-restaurant/restaurant-list/list-menu.component';
import { ProductMenuPageComponent } from './pages-restaurant/product-page/product-menu-page.component';
import { CategoryListContainerComponent } from './pages-restaurant/category-list-container/category-list-container.component';
import { SearchListContainerComponent } from './pages-restaurant/search-list-container/search-list-container.component';
import { PageCartComponent } from './modules/shop/pages/page-cart/page-cart.component';
import { PageCheckoutComponent } from './modules/shop/pages/page-checkout/page-checkout.component';
import { CheckoutGuard } from './modules/shop/guards/checkout.guard';
import { PageOrderSuccessComponent } from './modules/shop/pages/page-order-success/page-order-success.component';
import { RestaurantcartComponent } from './pages-restaurant/restaurantcart/restaurantcart.component';
import { RestaurantboxComponent } from './pages-restaurant/restaurantbox/restaurantbox.component';
import { RestaurantcheckoutComponent } from './pages-restaurant/restaurantcheckout/restaurantcheckout.component';
import { RestaurantordersuccessComponent } from './pages-restaurant/restaurantordersuccess/restaurantordersuccess.component';


const routes: Routes = [
    {
        path: 'siteinfo/version',
        component: SiteInfoComponent
    },
    {
        path: 'blocked',
        loadChildren: () => import('./modules/blocked/blocked.module').then(m => m.BlockedModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
        canActivate: [ShopBlockedGuard]
    },
    {
        path: 'admin/login',
        component: AdminPageComponent
    },
    {
        path: 'admin/preview',
        component: EditPageComponent
    },
    //Menu Component
    {
        path: 'menu/search',
        component: SearchListContainerComponent,
        data: { breadcrumb: 'Risultati ricerca' }
    },
     {
        path: 'menu/box/:codart',
        component: RestaurantboxComponent,
        data: { breadcrumb: 'Menu Componibili' }
    },
    {
        path: 'menu/:codice',
        component: CategoryListContainerComponent,
        data: { breadcrumb: 'Categoria' }
    },
    {
        path: 'menu/product/:codice',
        component: ProductMenuPageComponent,
        data: { breadcrumb: 'Prodotto' }
    },
    {
        path: 'shop/cart',
        pathMatch: 'full',
        component: RestaurantcartComponent
    },
    {
        path: 'shop/cart/checkout',
        component: RestaurantcheckoutComponent,
        canActivate: [CheckoutGuard],
    },
    {
        path: 'shop/cart/checkout/success',
        component: RestaurantordersuccessComponent,
    },
    {
        path: 'chi-siamo',
        component: PageChiSiamoComponent
    },
    {
        path: 'account',
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
        canActivate: [CanActivateIfLoggedIn]
    },
    {
        path: '',
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'classic',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        canActivate: [ShopBlockedGuard, CanActivateLoginRequired],
        children: [

           {
                path: 'pippo',
                loadChildren: () => import('./modules/shop/shop.module').then(m => m.ShopModule)
            },

            {
                matcher: policyDittaMatcher,
                component: PagePolicyDittaComponent
            },
            {
                path: '**',
                component: PageNotFoundComponent
            }
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'disabled',
    relativeLinkResolution: 'legacy'
})],
    exports: [RouterModule]
})
export class AppRoutingModule { }

export function policyDittaMatcher(url: UrlSegment[]) {
    if (url.length == 1) {
        if (url[0].path.endsWith('politiche-di-spedizione') || url[0].path.endsWith('politiche-di-reso') || url[0].path.endsWith('legale')) {
            return {consumed: url};
        }
    }
    return null;
}
